module.exports = __webpack_public_path__ + "img/icon_zdd.418a407d.png";